// Authentication API service
class AuthApiService {
  constructor() {
    this.baseURL = 'https://authalt.bsynapse.com/atmantannuggets'
  }

  // Login with username and password
  async login(username, password) {
    try {
      const response = await fetch(`${this.baseURL}/serverlogin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password, index: 'atmantan' })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('Login API request failed:', error)
      throw error
    }
  }
}

const authApiService = new AuthApiService()
export default authApiService

